import { cn } from "@client/utils/cn";
import {
  Checkbox,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormMessage,
} from "@sfc/ui";
import {
  type ControllerProps,
  type FieldPath,
  type FieldValues,
} from "react-hook-form";

export function FormCheckbox<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  className,
  labelClassName,
  checkboxClassName,
  control,
  name,
  label,
  description,
  ...rest
}: Omit<React.ComponentProps<typeof Checkbox>, "className"> & {
  className?: string;
} & Omit<ControllerProps<TFieldValues, TName>, "render"> & {
    labelClassName?: string;
    checkboxClassName?: string;
    label: string;
    description?: string;
  }) {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className={className}>
          <label className={cn("flex items-center gap-2", labelClassName)}>
            <FormControl>
              <Checkbox
                className={checkboxClassName}
                checked={field.value}
                onCheckedChange={field.onChange}
                {...rest}
              />
            </FormControl>
            {label}
          </label>
          {description && <FormDescription>{description}</FormDescription>}
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
